var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"outlined":"","disabled":_vm.disabled},on:{"click":function($event){return _vm.exportData()}}},[_c('v-icon',[_vm._v("mdi-arrow-top-right")]),_vm._v(" Export ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }